import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Product} from "@app/core/product/domain/dtos/product";
import {routesNames} from "@app/app-routing.module";

@Component({
  selector: 'ep-product-portrait-tile',
  templateUrl: './product-portrait-tile.component.html',
  styleUrls: ['./product-portrait-tile.component.scss']
})
export class ProductPortraitTileComponent {

  @Input() product?: Product;

  @Input() hasAddToListButton = true;

  @Input() hasAddToCartButton = true;

  @Input() hasAddToPdfButton = false;

  @Input() hasDeleteButton = false;

  @Input() displayPriceOnHover = false;

  @Output() onClickDeleteButton = new EventEmitter<Product>()

  @Output() onClick = new EventEmitter<Product | undefined>();

  routesNames = routesNames;

}
